import { useNavigate } from 'react-router-dom';
import { Crown, AlertCircle, Sparkles } from 'lucide-react';
import './SubscriptionBanner.css';

function SubscriptionBanner({ limits }) {
  const navigate = useNavigate();

  if (!limits) return null;

  const isPremium = limits.subscription?.isPremium;
  
  if (isPremium) {
    const expiresDate = new Date(limits.subscription.expiresAt).toLocaleDateString('ru-RU');
    return (
      <div className="subscription-banner premium">
        <Crown size={28} className="banner-icon" />
        <div className="banner-content">
          <h3>Premium подписка</h3>
          <p>Активна до {expiresDate}</p>
        </div>
        <Sparkles size={20} className="banner-sparkle" />
      </div>
    );
  }

  const docsRemaining = limits.documents.remaining;
  const showWarning = docsRemaining <= 1;

  return (
    <div className={`subscription-banner ${showWarning ? 'warning' : ''}`}>
      <AlertCircle size={24} className="banner-icon" />
      <div className="banner-content">
        <h3>Бесплатный план</h3>
        <p>
          Осталось {docsRemaining} из {limits.documents.limit} документов
        </p>
        <p>
          Печати: {limits.stamps.remaining} / Подписи: {limits.signatures.remaining}
        </p>
      </div>
      <button className="upgrade-button" onClick={() => navigate('/upgrade')}>
        <Crown size={16} />
        Upgrade
      </button>
    </div>
  );
}

export default SubscriptionBanner;

